import { render, staticRenderFns } from "./TimeComplex.vue?vue&type=template&id=40a05579&scoped=true&"
import script from "./TimeComplex.vue?vue&type=script&lang=js&"
export * from "./TimeComplex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a05579",
  null
  
)

export default component.exports